import { TrackEntry } from '@pixi-spine/runtime-4.1';
import { Spine } from 'pixi-spine';
import { BitmapText, Container, Text } from 'pixi.js';
import { container } from 'tsyringe';
import { Tweener } from '../../../core/tweener/engineTween';
// import { Tweener } from '../../../../../libs/engineTween';
import AssetsManager from '../../../core/assets/AssetsManager';
import Sound from '../../../core/sound/Sound';
import SoundManager from '../../../core/sound/SoundManager';
import Wallet from '../../../slots/model/Wallet';
import SoundList from '../../sound/SoundList';
import { ScreenOrientation } from '../../../core/view/ScreenOrientation';
import {UpdateLayoutDescription} from '../../../core/view/UpdateLayoutDescription';
import AdjustableLayoutContainer from '../../../core/view/AdjustableLayoutContainer';

export default class PopupBigWin extends AdjustableLayoutContainer {
    private levelAnimationNames: string[] = ['super', 'super', 'super', 'super', 'super'];
    private animations: Spine[];

    private levelAnimationDurations: number[] = [3, 3, 3, 3, 3];

    readonly level: number | (() => number);

    private winValue: number | (() => number);
    private _value: number;

    // VISUALS
    public animation: Spine;
    public tfAmount: Text | BitmapText;
    private orientation;
    private loopedSound: Sound;

    constructor(level: number | (() => number), winValue: number | (() => number), amountText: Text | BitmapText, orientation: ScreenOrientation) {
        super();

        // DisplayShortcuts.init();
        this.winValue = winValue;
        this.level = level;
        this.orientation = orientation

        this.animations = [
            new Spine(AssetsManager.spine.get('superWin')),
            new Spine(AssetsManager.spine.get('superWin')),
            new Spine(AssetsManager.spine.get('superWin')),
            new Spine(AssetsManager.spine.get('superWin')),
            new Spine(AssetsManager.spine.get('superWin')),
        ];
        // this.animations = asset instanceof Array
        // ? asset.map(data => new Spine(data))
        // : [ new Spine(asset) ]

        // this.tfAmount = amountText;
       this.tfAmount = new Text(amountText.text, {
        fontFamily: AssetsManager.getWebFontFamily('Rokkitt'),
        dropShadow: true,
        dropShadowAngle: 1.5,
        dropShadowBlur: 2,
        dropShadowColor: '#FF17B9',
        dropShadowDistance: 4,
        stroke: '#410456',
        strokeThickness: 3,
        fill: '#FFE614',
        fontSize: 110,
       })
        this.tfAmount.anchor.set(0.5, 0.5);
        this.tfAmount.scale.y = -1;
        const layout = AssetsManager.layouts.get('PopupBigWin');
        const animationLayout = layout.children.get('animation');
        this.animations.forEach((animation, i) => {
            const counterContainer = animation.slotContainers[animation.skeleton.findSlotIndex('text_box')];
            counterContainer.addChild(this.tfAmount);
            counterContainer.name = 'CounterContainer';
            animation.scale.set(animationLayout.scaleX, animationLayout.scaleY);
            animation.y = animationLayout.y
        });

        this.on('added', this.onAdded, this);
        this.on('removed', this.onRemoved, this);
    }

    // PUBLIC API
    public get value(): number {
        return this._value;
    }

    public set value(value: number) {
        this._value = value;

        const wallet: Wallet = container.resolve(Wallet);
        this.tfAmount.text = wallet.getCurrencyValue(value, true);
    }

    private get levelValue() {
        return this.level instanceof Function ? this.level() : this.level;
    }

    // PRIVATE API
    // private customClassElementCreate(le: LayoutElement): unknown {
    //     let instance: unknown = null;
    //     switch (le.customClass) {
    //         case "BigWinAnimation":
    //             switch (this.levelValue) {
    //                 case 0:
    //                     instance = new Spine(AssetsManager.spine.get("good_win"));
    //                     break;
    //                 case 1:
    //                     instance = new Spine(AssetsManager.spine.get("huge_win"));
    //                     break;
    //                 case 2:
    //                     instance = new Spine(AssetsManager.spine.get("great_win"));
    //                     break;
    //                 case 3:
    //                     instance = new Spine(AssetsManager.spine.get("insane_win"));
    //                     break;
    //             }
    //             break;
    //     }

    //     return instance;
    // }

    private onAdded(): void {
        if (this.levelValue == -1) {
            throw new Error('Big win level not set');
        }

        this.removeChild(this.animation);
        this.animation = this.animations[this.levelValue] ?? this.animations[0];
        this.addChild(this.animation);
        const counterContainer = this.animation.slotContainers[this.animation.skeleton.findSlotIndex('text_box')];
        // counterContainer.removeChildren();
        counterContainer.addChild(this.tfAmount);

        const levelAnimationDuration: number = this.levelAnimationDurations[this.levelValue];

        // spec says 5 secs animating, so we put 4 + 1 in + 1 out
        let numLoopAnimations: number = Math.ceil(5 / levelAnimationDuration);
        // this.animation.pivot.y=-this.animation.height/2;
        this.animation.state.setEmptyAnimations(0);
        const countUpDuration: number = 4;
        this.animation.state.addListener({
            start: (entry: TrackEntry) => {
                if (entry.animation.name.includes('in')) {
                    this.tfAmount.alpha = 0;
                    Tweener.addTween(this.tfAmount, {
                        alpha: 1,
                        time: 0.3,
                        // angle:90,
                        transition: 'easeOutQuad',
                        delay: 0.3,
                    });

                    this.tfAmount.scale.set(0.3, -0.3);
                    Tweener.addTween(this.tfAmount.scale, {
                        x: 3,
                        y: -3,
                        time: countUpDuration / 8,
                        transition: 'easeOutBack',
                        delay: 0.3,
                    });
                } else if (entry.animation.name.includes('out')) {
                    Tweener.addTween(this.tfAmount, {
                        alpha: 0,
                        time: 1,
                        transition: 'easeInQuad',
                        delay: 0.3
                    });
                }
            },
        });

        this.value = 0;
        Tweener.addTween(this, {
            value: this.winValue instanceof Function ? this.winValue() : this.winValue,
            time: countUpDuration,
            transition: 'easeInOutQuad',
            onStart: () => {
                this.loopedSound = SoundManager.play({
                    id: SoundList.COUNTER_LOOP,
                    volume: 0.25,
                });
            },
            onComplete: () => {
                this.loopedSound.stop();
                SoundManager.play({
                    id: SoundList.COUNTER_END,
                    volume: 0.4,
                });
            },
        });


        this.animation.stateData.setMix('Spawn', 'Idle', 0.7);
        this.animation.state.setAnimation(0, 'Spawn', false);
        if(this.levelValue == 4) numLoopAnimations = 4;
        for (let i = 0; i < numLoopAnimations; i++) {
            this.animation.state.addAnimation(0, 'Idle', false, 0);
        }
        this.animation.state.addAnimation(0, 'Despawn', false, 0);
    }

    private onRemoved(): void {
        if (this.loopedSound) this.loopedSound.stop();
        Tweener.removeTweens(this);
        Tweener.removeTweens(this.tfAmount);
        Tweener.removeTweens(this.tfAmount.scale);
        this.animations.forEach((animation) => {
            animation.state.setEmptyAnimations(0);
            animation.state.clearListeners();
            animation['lastTime'] = null;
        });
    }
    public skipCounter():void{
        Tweener.removeTweens(this);
        this.value =  this.winValue instanceof Function ? this.winValue() : this.winValue;
    }
    public updateLayout(desc: UpdateLayoutDescription) {
        super.updateLayout(desc);
        this.animations.forEach(a => a.scale.set(desc.orientation === ScreenOrientation.VERTICAL ? 1.1 : 1));
    }
}
